import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { GlobalRecentSubset } from '@/api/types/backend-dto-types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetGlobalRecentSubsets = () => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<GlobalRecentSubset[]>(
    [QueryEntity.GlobalRecentSubsets],
    async () => {
      const res = await fetch(`${APIBaseChronos}/api/matters/recent-subsets`, fetchConfigGET);
      if (!res.ok) {
        console.error('Failed to get global recent subsets');
      }
      return await res.json();
    },
    {
      refetchOnWindowFocus: false,
      retry: false,
    },
  );
};
